import { render, staticRenderFns } from "./SpecialTrad.vue?vue&type=template&id=5ec06e82&"
import script from "./SpecialTrad.vue?vue&type=script&lang=js&"
export * from "./SpecialTrad.vue?vue&type=script&lang=js&"
import style0 from "./SpecialTrad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports